import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MagnumResultModel } from 'src/app/models/magnum-result.model';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { QuoteModel } from 'src/app/models/quote.model';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-quote-result',
  templateUrl: './quote-result.component.html',
  styleUrls: ['./quote-result.component.scss'],
})
export class QuoteResultComponent implements OnInit {

  @Input() result: any;
  @Input() key: any;
  @Input() quickQuote: QQQuestionnaireViewModel;
  @Input() quote: QuoteModel;

  @Output() back = new EventEmitter();
  @Output() continue = new EventEmitter();
  @Output() newQuote = new EventEmitter();

  loading: boolean;
  errorKey: string;
  customError: string;
  answersObject: any;
  magnumPremium: MagnumResultModel;
  error = false;
  canProceed = true;
  canRequote = true;
  confirmRequote = false;
  headerLine1: string;
  headerLine2: string;
  subheader: string;
  
  constructor(
    private api: ApiService,
    private analyticsService: AnalyticsService
  ) { }

  async ngOnInit() {
    this.loading = false;
    this.getQuote();
    this.getHeaderLine1();
    this.getHeaderLine2();
  }

  OnViewWillEnter() {
    this.errorKey = null;
    this.confirmRequote = false;
    this.customError = null;
  }

  async getHeaderLine1() {
    const typeOfPol = this.getAnswer('TypeOfPolicy_1');
    this.headerLine1 = "Your Dividend Life Offer";
    if (typeOfPol == 'DUAL') {
      this.subheader = " - Dual Cover";
    }
  }

  async getHeaderLine2() {
    const inclCi = this.getAnswer('PolicyType_2');
    if (inclCi == 'TERM-CI') {
      this.headerLine2 = "Term Life with Multi-Claim Critical Illness Cover";
      // this.canRequote = false;
    }
  }

  getTitle(policyType: string) {
    if (policyType === 'TERM-CI')
      return "Term Life with Multi-Claim Critical Illness Cover";
    return "Term Life Cover";
  }

  async getQuote() {
    try {
      this.error = false;
      this.loading = true;

      try {
        var sourceUrl = this.analyticsService.getFullPath('full_quote');
        this.magnumPremium = await this.api.getMagnumPremium(this.quote.key, sourceUrl);

        if (this.magnumPremium.error) {
          this.customError = this.magnumPremium.error;
          this.error = true;
          return;
        }
      }
      catch (err: any) {
        this.error = true;
        if (err.error)
          this.errorKey = "FullQuote.Error";
        else
          this.customError = err.message;
        return;
      }

      this.quickQuote.saveAnswer("MagnumPremium", this.magnumPremium.basePremium.toFixed(2));
      this.quickQuote.saveAnswer("OriginalPremium", this.magnumPremium.originalPremium.toFixed(2));

      this.answersObject = this.quote.answers.toDictionary(x => x.key, x => x.value);
      
      this.errorKey = this.checkPolicyType();
      this.canProceed = !this.errorKey;
      this.logEvent(this.canProceed ? 'lead' : 'failed_lead');
    }
    catch (err: any) {
      this.errorKey = "FullQuote.Error";
      this.error = true;
      this.logEvent('failed_application');
    }
    finally {
      this.loading = false;
    }
  }

  private checkPolicyType() {    
    const hasCI = this.quote.answers.some(x => x.key.startsWith('PolicyType_') && x.value?.endsWith('-CI'));
    if (hasCI)
      return "FullQuote.CannotProceed-CI";
    
    //const singleOrDual = this.getAnswer('TypeOfPolicy_1');
    //if (singleOrDual !== 'SINGLE')
      //return "FullQuote.CannotProceed-DUAL";
    return null;
  }

  private getAnswer(key: string) {
    return this.quote.answers.find(x => x.key === key)?.value;
  }

  private logEvent(event: string) {
    //Log GTM event 
    let premium: string = this.quickQuote.answersObject['MagnumPremium'];
    let uid = this.quote?.result?.uid ?? this.quickQuote.answersObject["Uid"];
    let data: any = {
      page: this.analyticsService.getFullPath('full_quote'),
      leadType: 'fullQuote',
      amountPaid: premium,
      currency: 'GBP',
      firstName: this.getAnswer('FirstPolicyHolderFirstName'),
      lastName: this.getAnswer('FirstPolicyHolderSurName'),
      email: this.getAnswer('FirstPolicyHolderEmail'),
      uid: uid,
      quoteNo: this.quote.result?.quoteNo,
      leadkey: this.quote.parentKey ?? this.quote.key
    };

    this.analyticsService.logEvent(event, data);
  }
}
